<template>
    <div class="appointments">
        <ul class="list">
            <li v-for="(appointment, index) in appointmentsData" :key="index" class="appointment" :style="{ borderLeft: '5px solid ' + appointment.color }">
                <div class="event-info">
                    <div class="today-date">
                        <p class="day-name">{{ appointment.day }}</p>
                        <p class="real-date">{{ appointment.start | formatStartDate }}</p>
                    </div>
                    <div class="info-data">
                        <p class="event-title">{{appointment.name }}</p>
                        <p class="event-date">{{ appointment.start | formatStartTime }} - {{ appointment.end | formatStartTime }} </p>
                         <p class="event-date" v-if="appointment.location != null">{{ appointment.location.name }}</p>
                        <p class="event-desc">
                            <!-- <v-avatar size="28"><img :src="getThumbnailImg(appointment)" alt=""></v-avatar> -->
                            <v-avatar size="28"><img :src="appointment.trainer.profile_photo_url+'?w=56'" alt=""></v-avatar>
                            {{ appointment.trainer.full_name }}
                            
                        </p>
                    </div>
                </div>
                <div left>
                    <v-icon color="green">mdi-check-circle-outline</v-icon>
                </div>
            </li>
        </ul>
        <v-card v-if="appointments.length===0" class="mx-auto my-12" max-width="400" outlined>
            <v-card-text v-html="$page.props.lang.noEvents || 'There is no your appointment at the moment.'" class="text-center "></v-card-text>
        </v-card>

    </div> 
</template>

<script>
import PortalLayout from '@/js/Layouts/PortalLayout'
import Layout from './Layout/Default'
import moment from 'moment'
import EventBus from '../../../eventbus'

export default {
    metaInfo() {
        return {
            title: this.organization.name + ' - ' + (this.$page.props.lang.pastAppointments || "Past Appointments") 
        }
    },
    layout: (h, page) => {
      return h(PortalLayout, [
        h(Layout, [page]),
      ])
    },
    components: {
    },
    props: {
        appointments: Array,
        lang: Object,
        organization:Object
    },
    data(){
        return {
            weekDays: [
                { id: 0, text: (this.lang.monday || 'Monday').substr(0,3)},
                { id: 1, text: (this.lang.tuesday || 'Tuesday').substr(0,3)},
                { id: 2, text: (this.lang.wednesday || 'Wednesday').substr(0,3)},
                { id: 3, text: (this.lang.thursday || 'Thursday').substr(0,3)},
                { id: 4, text: (this.lang.friday || 'Friday').substr(0,3)},
                { id: 5, text: (this.lang.saturday || 'Saturday').substr(0,3)},
                { id: 6, text: (this.lang.sunday || 'Sunday').substr(0,3)}
            ],
            showCancelModal: false,
            eventForCancel: null
        }
    },
    computed: {
        appointmentsData() {
            let pack = Object.assign([], this.appointments)
            pack.map(item => {
                for (let i=0; i<this.weekDays.length; i++) {
                    if (moment(item.start).day()===0) {
                        item.day = this.weekDays[6].text
                    } else {
                        moment(item.start).day()===this.weekDays[i].id + 1 ? item.day = this.weekDays[i].text : ''
                    }
                }
            })
            // pack.filter(item => {return moment().isBefore(moment(item.start))})
            return pack
        },
        
    },
    getThumbnailImg(a){
        return a.trainer.profile_photo_url+'?w=28';
    },
    methods: {
  
    },
    filters: {
        formatStartDate(value) {
            return moment(value).format('DD.MM')
        },
        formatStartTime(value) {
            return moment(value).format('HH:mm')
        }
    }
}
</script>